const isReactNative = (globalThis as { navigator?: { product?: string } }).navigator?.product === "ReactNative";
const API_BASE = isReactNative ? "https://platko.simic.ltd" : "";

export { API_BASE };
